import React, { lazy } from "react";

const LazyDataOrchestration = lazy(() => import("./DataOrchestration"));

const DataOrchestration = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyDataOrchestration {...props} />;

export default DataOrchestration;
